export const BREAKDOWN_DETAILS_MODAL_TEXT = {
	title: 'Breakdown details',
	subtitle: 'Review the breakdown summary',
	close: 'Close',
	notAvailable: 'N/A',
};
